import { Suspense } from 'react';
import { CompanyEmployees } from '@features';
import { Skeleton, Stack } from '@mantine/core';

export const CompanyDetailsEmployeesPage: React.FC = () => {
  return (
    <Stack py="md">
      <Suspense fallback={<Skeleton mih={120} />}>
        <CompanyEmployees />
      </Suspense>
    </Stack>
  );
};
